import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1872585e")

_pushScopeId("data-v-1872585e")
const _hoisted_1 = { class: "p-d-flex p-flex-row" }
const _hoisted_2 = { class: "p-col-4 p-sm-4 p-md-3 p-m-0 p-p-0" }
const _hoisted_3 = { class: "p-col-8 p-sm-8 p-md-9 p-m-2 p-p-0" }
const _hoisted_4 = {
  key: 1,
  id: "no-dataset-selected-info",
  class: "p-d-flex p-flex-row p-jc-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FunctionsCatalogDatasetTable = _resolveComponent("FunctionsCatalogDatasetTable")
  const _component_FunctionsCatalogDatasetForm = _resolveComponent("FunctionsCatalogDatasetForm")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_FunctionsCatalogDatasetTable, {
        datasets: _ctx.datasets,
        onSelected: _ctx.loadSelectedDataset
      }, null, 8, ["datasets", "onSelected"])
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.selectedDataset)
        ? (_openBlock(), _createBlock(_component_FunctionsCatalogDatasetForm, {
            key: 0,
            selectedDataset: _ctx.selectedDataset,
            propFunction: _ctx.propFunction,
            pythonEnvironments: _ctx.pythonEnvironments,
            rEnvironments: _ctx.rEnvironments,
            onEnvironmentSelected: _ctx.onEnvironmentSelected,
            libraries: _ctx.libraries
          }, null, 8, ["selectedDataset", "propFunction", "pythonEnvironments", "rEnvironments", "onEnvironmentSelected", "libraries"]))
        : (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('managers.functionsCatalog.noDatasetSelected')), 1))
    ])
  ]))
})